import { logbaseService } from "./../../services/logbase.service";
import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-addserviceprovider",
  templateUrl: "./addserviceprovider.component.html",
  styleUrls: ["./addserviceprovider.component.scss"],
})
export class AddserviceproviderComponent implements OnInit {
  //configForm: FormGroup;

  selected = "";
  fieldsselection: any[] = [];
  configForm: FormGroup = new FormGroup({
    serviceProvierEn: new FormControl("", [
      Validators.required,
      Validators.pattern("^[A-Za-z\\s]+$"),
    ]),
    serviceProviderJp: new FormControl("", [
      Validators.required,
      Validators.pattern("^[一-龯ぁ-ゔ゙゚ァ-ヴー々〆〤ヶ]+$"),
    ]),
  });

  constructor(
    public dialogRef: MatDialogRef<AddserviceproviderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public logbaseService: logbaseService,
    public snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    console.log(this.data);
    if (this.data.type == "editServiceProvider") {
      this.configForm
        .get("serviceProvierEn")
        .setValue(this.data.serviceProviderData.serviceProvider);
      this.configForm
        .get("serviceProviderJp")
        .setValue(this.data.serviceProviderData.serviceProviderJp);
    } else if (this.data.type == "addServiceProvider") {
    }
  }

  getAddFormFieldsName(fieldName: string) {
    return this.configForm.get(fieldName);
  }

  getPrefecErrorMessage(value) {
    return value.hasError("required")
      ? this.translate.instant("Required")
      : value.hasError("pattern")
      ? this.translate.instant("Only Alphabets Allowed")
      : "";
  }

  onSubmit() {
    if (this.data.type == "editServiceProvider") {
      this.logbaseService
        .postServiceProvider({
          id: this.data.serviceProviderData.id,
          serviceProviderJP: this.configForm.get("serviceProviderJp").value,
          serviceProvider: this.configForm.get("serviceProvierEn").value,
          user: JSON.parse(localStorage.getItem("currentUser")),
        })
        .subscribe(
          (result) => {
            if (result.status.statusMessage == "SUCCESS") {
              this.dialogRef.close("Updated");
              this.snackBar.open("Successfully Updated", "", { duration: 2000 });
            } else {
              this.snackBar.open(result.status.displayMessage || "Update failed", "", { duration: 3000 });
            }
          },
          (error) => {
            this.snackBar.open("An error occurred during update", "", { duration: 3000 });
            console.error('Error:', error);
          }
        );
    } else if (this.data.type == "deleteServiceProvider") {
      const id = this.data.serviceProviderData.id;
      this.logbaseService.deleteServiceProvider(id).subscribe(
        (result) => {
          if (result.status.statusMessage == "SUCCESS") {
            this.dialogRef.close("Deleted");
            this.snackBar.open("Successfully Deleted", "", { duration: 2000 });
          } else {
            this.snackBar.open(result.status.displayMessage || "Delete failed", "", { duration: 3000 });
          }
        },
        (error) => {
          this.snackBar.open("An error occurred during deletion", "", { duration: 3000 });
          console.error('Error:', error);
        }
      );
    } else {
      this.logbaseService
        .postServiceProvider({
          serviceProviderJP: this.configForm.get("serviceProviderJp").value,
          serviceProvider: this.configForm.get("serviceProvierEn").value,
          user: JSON.parse(localStorage.getItem("currentUser")),
        })
        .subscribe(
          (result) => {
            if (result.status.statusMessage == "SUCCESS") {
              this.dialogRef.close("Added");
              this.snackBar.open("Successfully Added", "", { duration: 2000 });
            } else {
              this.snackBar.open(result.status.displayMessage || "Addition failed", "", { duration: 3000 });
            }
          },
          (error) => {
            this.snackBar.open("An error occurred during addition", "", { duration: 3000 });
            console.error('Error:', error);
          }
        );
    }
  }
  

  onNoClick(): void {
    this.dialogRef.close("Close");
  }
}
